const CLASS_ACTIV = 'activ'
const CLASS_TOGGLE_CHECKBOX = 'js-toggle-checkbox'

export default {
  /**
   * @description Initialise validation
   * @returns {undefined}
   */
  init() {
    this.bind()
  },
  
  bind() {
    document.getElementsByClassName(CLASS_TOGGLE_CHECKBOX)
            .bindEvent('click', this.toggleAll)
    Array.prototype.forEach.call(document.getElementsByClassName(CLASS_TOGGLE_CHECKBOX), element => {
      element.parentNode.bindEvent('change', this.checkToggleAll)
    })
  },
  
  toggleAll(e) {
    e.preventDefault()
    const current = e.currentTarget
    const status = !current.classList.contains(CLASS_ACTIV)
    if (status) {
      current.classList.add(CLASS_ACTIV)
    } else {
      current.classList.remove(CLASS_ACTIV)
    }
    Array.prototype.forEach.call(current.parentNode.getElementsByTagName('input'), element => {
      if (element.type === 'checkbox') {
        element.checked = status
      }
    })
  },
  
  checkToggleAll(e) {
    const current = e.currentTarget
    const toggleCheckbox = current.getElementsByClassName(CLASS_TOGGLE_CHECKBOX).item(0)
    let allChecked = true
    Array.prototype.forEach.call(current.getElementsByTagName('input'), element => {
      if (!element.checked) {
        allChecked = false
      }
    })
    if (allChecked) {
      toggleCheckbox.classList.add(CLASS_ACTIV)
    } else {
      toggleCheckbox.classList.remove(CLASS_ACTIV)
    }
  }
}



// WEBPACK FOOTER //
// ./src/apps/Front/private/js/components/toggleCheckbox.js